export {default} from '../../../core/components/Repository/FieldCurrency';